import { useState, useEffect } from "react";
import { Dropdown, Loader } from "semantic-ui-react";

// components
import TooltipCustom from "../../atoms/tooltipCustom";
// icons
import infoBlackIcon from "../../../assets/image/icons/tables/info-black.svg";
import iconArrow from "../../../assets/image/icons/png/arrow-green.png";

import { api } from "../../../api/api";
import { statesDescriptor } from "../../../api/statesDescriptor";

const InformationBlock = (props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [executionsList, setExecutionsList] = useState([]);
  const [currentId, setCurrentId] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [campaignState, setCampaignState] = useState([]);
  const getExecutionsContact = async () => {
    let arrayIdCampaigns;
    let data;
    try {
      if (currentId) {
        arrayIdCampaigns = await api.getContactsExecutionsApi({
          filter: `(linkedin_contact/id eq '${currentId}')`,
          orderby: "created desc",
        });
        if (arrayIdCampaigns.data.documents.length > 0) {
          setCampaignState(
            arrayIdCampaigns.data.documents.reduce((acc, doc) => {
              acc[doc.campaign_id] = doc.state;
              return acc;
            }, {})
          );
          const campaignIds = arrayIdCampaigns.data.documents.map(
            (doc) => doc.campaign_id
          );

          data = await api.getCampaignsApi({
            filter: `id in ('${campaignIds.join("', '")}')`,
          });
          setExecutionsList(data.data.documents);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentId) {
      getExecutionsContact();
    }
  }, [currentId]);

  const menuClasses = () => {
    if (props.size > 6) {
      if (props.index > props.size - 3) {
        return "position-top";
      }
    }
    return "position-bottom";
  };

  const upwardController = () => {
    if (props.size > 6) {
      if (props.index > props.size - 3) {
        return true;
      }
    }
    return false;
  };

  return (
    <div className="container-info">
      <Dropdown
        upward={upwardController()}
        className={"btn-row btn-drop"}
        onOpen={() => {
          setIsModalVisible(true);
          props.dropDownController(props.row.id);
          setCurrentId(props.row.id);
          setLoading(true);
        }}
        onClose={() => {
          setIsModalVisible(false);
          props.dropDownController("");
          setCurrentId("");
        }}
        icon={
          <TooltipCustom isVisible={!isModalVisible} title={""} arrow={true}>
            <img className="icon" src={infoBlackIcon} alt="infoBlackIcon" />
          </TooltipCustom>
        }
      >
        <Dropdown.Menu className={menuClasses()}>
          <Dropdown.Item>
            <div className="drop-down-container-contacts">
              {isLoading || !currentId ? (
                <div className="container-loader-campaigns">
                  <Loader size="small" active={true} />
                </div>
              ) : (
                <>
                  <p className="text-dropdown--title">
                    Participate in campaigns
                  </p>
                  {executionsList.length === 0 ? (
                    <div className="text-dropdown-sub-title">No campaigns</div>
                  ) : (
                    <>
                      {executionsList?.map((item) => (
                        <div
                          key={item.name}
                          className="drop-down-container__list-contacts"
                        >
                          <div className="drop-down-container__item">
                            <div className="wrapper-title-container">
                              <div
                                onClick={() => {
                                  const url = item.archived
                                    ? `/archive/${item.id}`
                                    : `/campaigns/${item.id}`;
                                  window.open(url, "_blank");
                                }}
                                className="text-dropdown-title"
                              >
                                <div className="text-dropdown-sub-title">
                                  {item.name}
                                </div>
                                <img
                                  className="icon-arrow"
                                  src={iconArrow}
                                  alt="infoBlackIcon"
                                />
                              </div>
                            </div>
                            <div className="dropdown-flex-container">
                              <div
                                style={{
                                  background: statesDescriptor.detectColor(
                                    campaignState[item.id]
                                  ),
                                }}
                                className="circus-block"
                              />
                              <div className="text-dropdown-state">
                                {statesDescriptor.getExecutionTitle(
                                  campaignState[item.id]
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </>
              )}
            </div>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default InformationBlock;
